import { getScoreReaderValenceSums, getScoreReaderTotal } from '@upright/common/model/output/scores/score-reader';
import { NetScoreFormat } from '@upright/common/model/output/scores/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { getValueSet } from '@upright/ui/untidy/redux/selectors';
import { useSelector } from 'react-redux';

export type NetScore = {
  value: number | undefined;
  valenceSums: {
    pos: number | undefined;
    neg: number | undefined;
    net: number | undefined;
  };
};

export function useNetScoreWithoutValueSet(aggregateMetric: NetScoreFormat): NetScore | undefined {
  const context = useNetImpactLensContext();
  const { options } = context ?? {};
  const scoreReader = options?.scoreReader;
  if (!scoreReader) {
    return undefined;
  }
  const value = getScoreReaderTotal(scoreReader, aggregateMetric);
  const valenceSums = getScoreReaderValenceSums(scoreReader);
  return { value, valenceSums };
}

export function useNetScoreAdjustedWithValueSet(aggregateMetric: NetScoreFormat): NetScore | undefined {
  const valueSet = useSelector(getValueSet);
  const context = useNetImpactLensContext();
  const { options } = context ?? {};
  const { scoreReader } = options ?? {};
  if (!scoreReader) {
    return undefined;
  }
  const scoreReaderWithSelectedValueSet = scoreReader.clone({ valueSet });
  const value = getScoreReaderTotal(scoreReaderWithSelectedValueSet, aggregateMetric);
  const valenceSums = getScoreReaderValenceSums(scoreReaderWithSelectedValueSet);
  return { value, valenceSums };
}
